export default __webpack_public_path__ + "static/media/meterGuide.86a786ad.png";